module.exports = __webpack_public_path__ + "img/google_play.bede9f15.png";